import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { apiService } from '../services/api';
import './Registration.css'; // Reusing registration styles

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    mobile_no: '',
    dob: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Redirect if already logged in
  React.useEffect(() => {
    const userId = sessionStorage.getItem('userId');
    const userName = sessionStorage.getItem('userName');
    if (userId && userName) {
      navigate(`/dashboard/${encodeURIComponent(userName)}`);
    }
  }, [navigate]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const validateForm = () => {
    const { name, mobile_no, dob } = formData;
    
    if (!name.trim()) {
      setError('Name is required');
      return false;
    }
    
    if (!mobile_no.trim() || !/^\d{10,15}$/.test(mobile_no)) {
      setError('Valid mobile number is required (10-15 digits)');
      return false;
    }
    
    if (!dob) {
      setError('Date of birth is required');
      return false;
    }
    
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!validateForm()) {
      return;
    }
    
    setLoading(true);

    try {
      const response = await apiService.loginUser(formData);
      console.log('Login successful:', response);
      const userId = response.user_id;
      const userName = response.name;
      // Save ID and Name to session storage so PhotoUpload/Dashboard knows which user it is
      sessionStorage.setItem('userId', String(userId));
      sessionStorage.setItem('userName', userName);
      navigate(`/dashboard/${encodeURIComponent(userName)}`);
    } catch (err) {
      console.error('Login error:', err);
      setError(err.response?.data?.error || 'Login failed. Please check your details.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: '480px', margin: '3rem auto', padding: '0 1rem' }}>
      <div className="landing-register-card" style={{ boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)' }}>
        <div className="register-card-header">
          <span style={{
            display: 'inline-block',
            background: '#eff6ff',
            color: '#2563eb',
            fontSize: '0.72rem',
            fontWeight: 800,
            padding: '0.25rem 0.65rem',
            borderRadius: '999px',
            marginBottom: '0.65rem',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }}>
            Participant Portal
          </span>
          <h2 className="register-card-title">User Sign In</h2>
          <p className="register-card-sub">
            Enter your registered credentials to resume verification or access your submissions
          </p>
        </div>

        <form onSubmit={handleSubmit} className="embedded-reg-form">
          <div className="reg-field-group">
            <label htmlFor="name">Full Name:</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter your registered full name"
              autoComplete="name"
              required
            />
          </div>

          <div className="reg-field-group">
            <label htmlFor="mobile_no">Mobile Number:</label>
            <input
              type="tel"
              id="mobile_no"
              name="mobile_no"
              value={formData.mobile_no}
              onChange={handleChange}
              placeholder="Enter your registered mobile number"
              autoComplete="tel"
              required
            />
          </div>

          <div className="reg-field-group">
            <label htmlFor="dob">Date of Birth:</label>
            <input
              type="date"
              id="dob"
              name="dob"
              value={formData.dob}
              onChange={handleChange}
              required
            />
          </div>

          {error && <div className="reg-error-banner">⚠️ {error}</div>}

          <button
            type="submit"
            className="btn-hero-primary reg-submit-btn"
            disabled={loading}
          >
            {loading ? 'Authenticating...' : 'Sign In & Continue →'}
          </button>

          <div className="reg-alt-link-row">
            <span>Don't have an account yet? </span>
            <Link to="/register" style={{ color: '#2563eb', fontWeight: 700, textDecoration: 'none' }}>
              Register here
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
